import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo:{},
    nowid:""//链接后的id
  },
  mutations: {
  
  },
  actions: {
  },
  modules: {
  }
})
